module.exports = __webpack_public_path__ + "static/media/football-fireworks.e4e086d0.png";